// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"9229f9f2","97":"c6261c0f","330":"c76e5618","331":"c1bd0122","574":"49428a7c","622":"dfd05a2c","675":"42a30c6f","774":"71f6224c","835":"ba3f1ffc"}[chunkId] + ".chunk.js";
};